<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-card-title>Guest Login</v-card-title>
          <v-container>
            <v-row dense>
              <v-col cols="12">
                <div class="body-1">
                  You do not need user registration in the guest page. However, everybody can check and download the prediction results.<br>
                  If you want to avoid this problem, please register user information and login.
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions class="d-flex justify-end">
            <v-btn @click="guestLogin">Guest Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card class="mx-auto">
          <v-card-title>Login</v-card-title>
          <ValidationObserver ref="form" v-slot="{ invalid }" immediate>
            <v-form v-model="valid">
              <v-container>
                <v-row dense>
                  <v-col cols="12">
                    <div class="d-flex justify-end">
                      <router-link to="/register">Click here to register user</router-link>
                    </div>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                       name="User ID"
                       rules="required"
                    >
                        <v-text-field
                          label="User ID"
                          v-model="credentials.username"
                          :error-messages="errors"
                          :success="valid">
                        </v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider
                      v-slot="{ errors, valid }"
                      name="Password"
                      rules="required"
                    >
                        <v-text-field
                          label="Password"
                          v-model="credentials.password"
                          type="password"
                          :error-messages="errors"
                          :success="valid">
                        </v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-container>
              <v-card-actions class="d-flex justify-end">
                <v-btn @click="login" :disabled="invalid">Login</v-btn>
              </v-card-actions>
            </v-form>
          </ValidationObserver>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { mapActions } from "vuex";
import axios from 'axios';
import router from '../router';

export default {
  data: () => ({
    valid: true,
    credentials: {},
  }),
  methods: {
    ...mapActions("util", ["showProgress", "hideProgress", "openSnackbar", "closeSnackbar", ]),
    guestLogin: function() {
      this.credentials.username = 'guest';
      this.credentials.password = 'guest';
      this.login();
    },
    login: function() {
      this.showProgress();
      axios.post('/auth/', this.credentials).then(response => {
        this.$session.start();
        this.$session.set('token', response.data.token);
        this.$session.set('userName', this.credentials.username);
        this.$store.dispatch('updateUserName', this.credentials.username);
        this.hideProgress();
        router.push('/');
      // eslint-disable-next-line
      }).catch(e => {
        this.hideProgress();
        this.openSnackbar({ text:'Incorrect login information.', color:'error' });
      })
    }
  }
}
</script>
